import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/home/index.vue'
import community from '../views/community/index.vue'
import myassets from '../views/myassets/index.vue'
import mycontribution from '@/views/mycontribution/index.vue'
import rankingyesterday from '@/views/rankingyesterday/index.vue'
import receiverecord from '@/views/receiverecord/index.vue'
import examples from '@/views/examples/index.vue'
import shopRoutes from '../../shop-system/src/router/shopRouter'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/refer/:refer',
    name: 'refer',
    component: HomeView
  },
  {
    path: '/community',
    name: 'community',
    component: community
  },
  {
    path: '/myassets',
    name: 'myassets',
    component: myassets
  },
  {
    path: '/mycontribution',
    name: 'mycontribution',
    component: mycontribution
  },
  {
    path: '/rankingyesterday',
    name: 'rankingyesterday',
    component: rankingyesterday
  },
  {
    path: '/receiverecord',
    name: 'receiverecord',
    component: receiverecord
  },
  // 商铺系统路由
  ...shopRoutes
]

const router = new VueRouter({
  routes,
  mode: 'history',
  base: '/',
});
router.beforeEach((to, from, next) => {
  try {
    if(to.params.refer){
      console.log(to.params.refer, to, "refer router.beforeEach"); // 获取动态参数
      sessionStorage.setItem('refer',to.params.refer);
    }
    // 调用 next() 让路由继续执行
    next();
  } catch (error) {
    console.error('Router beforeEach error:', error);
    const errorLog = {
      timestamp: new Date().toISOString(),
      type: 'router_beforeEach',
      error: error.message,
      stack: error.stack,
      route: to.path
    };
    const existingErrors = JSON.parse(localStorage.getItem('routerErrors') || '[]');
    existingErrors.push(errorLog);
    localStorage.setItem('routerErrors', JSON.stringify(existingErrors));
    // 即使出错也要让路由继续
    next();
  }
});

router.afterEach((to,from)=>{
  try {
    setTimeout(() => {
      window.scrollTo(0,0)
    }, 0);
  } catch (error) {
    console.error('Router afterEach error:', error);
    const errorLog = {
      timestamp: new Date().toISOString(),
      type: 'router_afterEach',
      error: error.message,
      stack: error.stack,
      from: from.path,
      to: to.path
    };
    const existingErrors = JSON.parse(localStorage.getItem('routerErrors') || '[]');
    existingErrors.push(errorLog);
    localStorage.setItem('routerErrors', JSON.stringify(existingErrors));
  }
});

// 添加路由错误处理
router.onError((error) => {
  console.error('Router error:', error);
  const errorLog = {
    timestamp: new Date().toISOString(),
    type: 'router_error',
    error: error.message,
    stack: error.stack
  };
  const existingErrors = JSON.parse(localStorage.getItem('routerErrors') || '[]');
  existingErrors.push(errorLog);
  localStorage.setItem('routerErrors', JSON.stringify(existingErrors));
});

export default router
